import { render, staticRenderFns } from "./userSettingsToken.vue?vue&type=template&id=1d45884b"
import script from "./userSettingsToken.vue?vue&type=script&lang=js"
export * from "./userSettingsToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports